var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{staticClass:"bf-markdown",attrs:{"postrender":_vm.trimOutput}},[_vm._t("default")],2)}]

export { render, staticRenderFns }